import React from 'react';

const MARK_URL = `${process.env.PUBLIC_URL || ''}/brand/sinatra-mark.svg`;

// Sinatra tile mark (public/brand/sinatra-mark.svg): 3x3 mosaic in the Tileward palette
export function SinatraMark({ size = 22 }) {
  return (
    <img
      className="sinatra-brand__mark"
      src={MARK_URL}
      width={Math.round(size * 316 / 234)}
      height={size}
      alt=""
    />
  );
}

// The Tileward lockup: the mark beside the company's name, with the product under it. The words
// take their size from the font size around them.
export default function SinatraLogo({ markSize = 32 }) {
  return (
    <span className="sinatra-brand">
      <SinatraMark size={markSize} />
      <span className="sinatra-brand__words">
        <span className="sinatra-brand__company">Tile<span className="sinatra-brand__ward">ward</span></span>
        <span className="sinatra-brand__product">Sinatra</span>
      </span>
    </span>
  );
}
